import { render, staticRenderFns } from "./main-index.vue?vue&type=template&id=2ead344b&"
import script from "./main-index.vue?vue&type=script&lang=js&"
export * from "./main-index.vue?vue&type=script&lang=js&"
import style0 from "./main-index.vue?vue&type=style&index=0&id=2ead344b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports